import {ANTIBODY_SCHEMA_INTERFACE_ID} from 'antibodies/schema-configuration/AntibodySchemaInterfaceConstants';
import ModelTypeConstants, {SearchableExclusiveSSIType} from 'constants/ModelTypeConstants';
import {EQUIPMENT_SCHEMA_INTERFACE_ID} from 'instruments/equipment/EquipmentConstants';
import {ComplexPolymerInterfaceApiId} from 'modbio/complex-polymers/ComplexPolymerSchemaInterfaceConstants';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {FolderItemIcon} from 'ui-library/icons/IconConstants';
import {assertNever} from 'util/Types';

export function getSearchableExclusiveSsiInterfaceId(type: SearchableExclusiveSSIType): string {
  // Resolved at call time rather than in a module-level map: AntibodySchemaInterfaceConstants imports this
  // module back through ApolloWrappers -> ItemListing -> SearchUtil, so its exports may not be initialized
  // yet when this module is evaluated.
  switch (type) {
    case ModelTypeConstants.ANTIBODY:
      return ANTIBODY_SCHEMA_INTERFACE_ID;
    case ModelTypeConstants.OLIGO_CONJUGATE:
      return ComplexPolymerInterfaceApiId.OLIGO_CONJUGATE_ID;
    case ModelTypeConstants.OLIGO_DUPLEX:
      return ComplexPolymerInterfaceApiId.OLIGO_DUPLEX_ID;
    case ModelTypeConstants.EQUIPMENT:
      return EQUIPMENT_SCHEMA_INTERFACE_ID;
    default:
      return assertNever(type);
  }
}

/**
 * Not every exclusive SSI type name is a valid icon name, so callers that render a type as an icon use this.
 */
export function getSearchableExclusiveSsiIcon(type: SearchableExclusiveSSIType): BenchlingIconName {
  switch (type) {
    case ModelTypeConstants.ANTIBODY:
      return FolderItemIcon.Antibody;
    case ModelTypeConstants.OLIGO_CONJUGATE:
    case ModelTypeConstants.OLIGO_DUPLEX:
      return FolderItemIcon.OligoConjugate;
    case ModelTypeConstants.EQUIPMENT:
      return FolderItemIcon.Equipment;
    default:
      return assertNever(type);
  }
}
